import { ItrColumnDefDirective } from '../directives/itr-column-def.directive';
import { ElementRef } from '@angular/core';

export class BaseItrCell {
  constructor(columnDef: ItrColumnDefDirective, elementRef: ElementRef) {
    const columnClassName = `itr-column-${columnDef.cssClassFriendlyName}`;
    elementRef.nativeElement.classList.add(columnClassName);
  }
}
